<script>

import {sendAppMessage} from "@/util/sendAppMessage";

export default {
  name: "collect",
  components: {

  },
  data() {
    return {
      list: []
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      const res = await this.$axios.get("shorts/getShortsCollectList")
      if(res.code == 10001) {
        this.list = res.data;
        console.log(this.list);
      }
    },
    onBack() {
      sendAppMessage({jump_type: 0, jump_url: ""});
    }
  }
};
</script>

<template>
  <div class="collect bg-black w-full">
    <div class="title">
      <div class="back" @click="onBack">
        <van-icon size="26" class="text-xl" color="#FFF" name="arrow-left"/>
      </div>
      <div class="texts flex justify-center items-center space-x-8">
        <h1 class="text-white" @click="$router.replace('/moment')">今日集萃</h1>
        <h1 style="color: #F00">我的收藏</h1>
      </div>
    </div>
    <div class="list-container" v-if="list && list.length > 0">
      <div  class="list pt-14 px-3 grid grid-cols-2 gap-3">
        <div v-for="item in list" :key="item.id" class="item" @click="$router.push(`/moment/collect-play?id=${item.shorts.id}`)">
          <img :src="item.shorts.img" alt="" class="w-full">
          <div class="count">
            <p><van-icon color="#FFF" name="like" /><span class="ml-1">{{ item.shorts.like_num }}</span></p>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="empty">
      <van-empty description="暂无收藏" image="search" />
    </div>
  </div>
</template>

<style scoped>

.list-container {
  height: 100vh;
  overflow-y: auto;
  padding-bottom: 1rem;
}

.title {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2;
  background-color: #000;
  @apply h-14 flex items-center;
}

.title .texts {
  width: 100%;
}

.title h1 {
  @apply text-base;
  font-weight: bold;
}

.title .back {
  position: absolute;
  left: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
}
/*
.item:nth-child(odd) {
  @apply mr-1.5;
}
.item:nth-child(even) {
  @apply ml-1.5;
}
*/

.item {
  @apply relative;
}

.count {
  @apply px-1 text-sm;
  position: absolute;
  bottom: 0;
  height: 30%;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.2) 100%);
  color: #FFF;
}

.empty {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #FFF;
}
</style>
